class Component {
    reactivityOptions;
    element;
    type;
    constructor(element, type) {
        this.element = element;
        this.type = type;
    }
}
export default Component;
